/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshNftMetadataBody
 */
export interface RefreshNftMetadataBody {
    /**
     * 
     * @type {string}
     * @memberof RefreshNftMetadataBody
     */
    trackerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RefreshNftMetadataBody
     */
    isUpdateAll: boolean;
}

export function RefreshNftMetadataBodyFromJSON(json: any): RefreshNftMetadataBody {
    return RefreshNftMetadataBodyFromJSONTyped(json, false);
}

export function RefreshNftMetadataBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshNftMetadataBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trackerId': !exists(json, 'trackerId') ? undefined : json['trackerId'],
        'isUpdateAll': json['isUpdateAll'],
    };
}

export function RefreshNftMetadataBodyToJSON(value?: RefreshNftMetadataBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trackerId': value.trackerId,
        'isUpdateAll': value.isUpdateAll,
    };
}


